import { render, staticRenderFns } from "./StimulsoftViewer.vue?vue&type=template&id=601845da&scoped=true&"
import script from "./StimulsoftViewer.vue?vue&type=script&lang=ts&"
export * from "./StimulsoftViewer.vue?vue&type=script&lang=ts&"
import style0 from "./StimulsoftViewer.vue?vue&type=style&index=0&id=601845da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601845da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSpacer})
